var render, staticRenderFns
import script from "./InlineLoader.vue?vue&type=script&lang=tsx"
export * from "./InlineLoader.vue?vue&type=script&lang=tsx"
import style0 from "./InlineLoader.vue?vue&type=style&index=0&id=84ec4d02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ec4d02",
  null
  
)

export default component.exports